import "xstyle/css!jquery-ui-themes/base/all.css";
import "jquery-chosen";
import "jquery/ui/autocomplete";

import $ = require("jquery");
import _ = require("underscore");
import Marionette = require("backbone.marionette");
import template = require("../templates/bookmarks-template");
import Portal = require("portal-gis");
import Model = require("../models/base-model");
import Base = require("./base-view");

class BookmarkView extends Base<Portal.MapBookmarkLeaf> {

    static about = `
The app/controls/bookmark-picker uses this view to render bookmarks.
    `;

    execute(options) {
        this.template = template;
        this.tagName = "select";
        this.className = "bookmark";
        this.events = <any>{
            "change": "onChange"
        };

        this.collectionEvents = {
            'add': 'modelChanged'
        };

        this.modelEvents = {
            "change": "modelChanged"
        };

        return super.execute(options);
    }

    // you'd think this would happen automatically...maybe I need to call a method on the collection?
    modelChanged() {
        console.log("bookmarks added:", this.collection.length);
        _.debounce(() => this.render(), 250)();
    }

    onChange(event: JQueryEventObject) {
        var model = this.collection.get(event.target["value"]);
        model && this.trigger("bookmark-selected", {
            model: model
        });
    }

}

export = BookmarkView; 